import React from 'react';
import $ from "jquery";
//import {getLVDocumentDB} from "../../Database/lvDocumentDAO";
//import {getAllAnnotationsDB} from "../../Database/AnnotationsDAO";
import {clearHTML, setAnnotationStale} from "../../Utils/helpers";
import '../../Styles/Annotator/AIHighlights.css';
import '../../index.css';


//function ShowHighlightsComponent(listener, setListener, lvCustomerView) {
function ShowHighlightsComponent(props) {
    setTimeout(render, 100)

    async function render() {
        await renderHighlights();

        // We need to have a set timeout for certain seconds for example 3500 when we save the state via API call
        await showHighlights();
        if (props.annotations && props.lvreportDisplay) {
            changeColorForReport()
        }

        //Changing the annotations color for report view
        function changeColorForReport() {
            props.annotations.forEach((i) => {
                if (document.getElementById(i.unique_id) !== null){
                    if (i.type === "Hinweis") {
                        document.getElementById(i.unique_id).className = "reportHinweis"
                    }
                    if (i.type === "Risiko") {
                        document.getElementById(i.unique_id).className = "reportRisiko"
                    }
                    if (i.type === "Potenzial") {
                        document.getElementById(i.unique_id).className = "reportPotenzial"
                    }
                }}
            )
        }


    }

    /***

     * Updates the Annotation Form with respective data of an annotation.
     * Also, checks if user is intended to see web report specific data

     * @param annotationID

     * @param annotDataValue

     * @param isWebReport

     * @param setListener

     */

    function updateAnnotatorUI(annotationID, annotDataValue, isWebReport) {

        let mark = document.getElementById(annotationID);

        // if (mark === null) {
        // 	setListener('no')
        // } else {
        // 	setListener('yes')
        // }

        if (mark !== null) {

            mark.innerHTML = mark.innerHTML.replace(/(\r\n|\n|\r)/gm, "");

        }

        if (mark !== null && mark !== undefined) {

            mark.addEventListener("click", function () {

                $("mark").removeClass("dashed-border-mark");

                $(this).addClass("dashed-border-mark");

                let norm = clearHTML(annotDataValue.norm)
                localStorage.setItem("advicePreSearchTerm", norm.toString())

                localStorage.setItem("annotationID", annotationID);

                $("#norm").val(norm.toString());

                $("#advice").val(clearHTML(annotDataValue.advice));

                $("#agl").val(clearHTML(annotDataValue.law));

                $("#kommentor").val(clearHTML(annotDataValue.kommentor));

                $("#category").val(clearHTML(annotDataValue.type));

                if (annotDataValue.formula !== "") {
                    $("#formel").val(clearHTML(annotDataValue.formula));
                } else {
                    $("#formel").val("keine Formel");
                }

                $("#ursache").val(clearHTML(annotDataValue.Annotation));

                if (isWebReport === "true") {
                    let advice = clearHTML(annotDataValue.advice);
                    let formula = clearHTML(annotDataValue.formula);
                    $("#Empfehlung").val(`${advice} ${formula}`);
                }


            });

        }

    }

    /***
     /***
     * Scrolls the UI to the last highlight / annotation made by Analyst
     */
    // async function goToLastAnnotationOnUI() {
    // 	//Retrieve the annotation ID of last highlight
    // 	let allAnnotations = await getAllAnnotationsDB();
    //
    // 	if (allAnnotations === undefined)//allAnnotations
    // 	{
    // 		return;
    // 	}
    //
    // 	//If there are no annotations for an LV, then no scroll happens.
    // 	if (allAnnotations.length !== 0) {
    // 		//Find the recent timestamp
    // 		let recentTimeStamp = allAnnotations.reduce(
    // 			(previousAnnotation, currentAnnotation, currentIndex) =>
    // 				currentAnnotation.annotation_data.timestamp >
    // 				previousAnnotation.annotation_data.timestamp && currentIndex
    // 					? currentAnnotation
    // 					: previousAnnotation
    // 		).annotation_data.timestamp;
    //
    // 		//Retrieve the annotation ID of respective recent timestamp
    // 		let lastAnnotationID = "";
    // 		for (let annotation of allAnnotations) {
    // 			if (annotation.annotation_data.timestamp === recentTimeStamp) {
    // 				lastAnnotationID = annotation.annotation_data.unique_id;
    // 			}
    // 		}
    //
    // 		//Updates UI with last annotation view
    // 		if (document.getElementById(lastAnnotationID) !== null) {
    // 			document
    // 				.getElementById(lastAnnotationID)
    // 				.scrollIntoView({behavior: "smooth"});
    // 		}
    // 	}
    // }

    /***
     * Renders the highlights from the data retrieved from lv document, by updating position texts.
     */


    /***
     * Renders the highlights from the data retrieved from lv document, by updating position texts.
     */
    async function renderHighlights() {
        if (props.lvstatus === "search" && localStorage.getItem("annotationJustCreated") === "true") {
            localStorage.removeItem("annotationJustCreated");
            return;
        }
        if (props.lvDocument) {
            let lvDocument = props.lvDocument
            if (lvDocument) {
                //lvDocument = JSON.parse(lvDocument[0].data);
                // render the inner html of all positions with annotations from the past.
                for (let position of lvDocument) {
                    if (position.id.length !== 0) {
                        let positionID = position.id;
                        if (document.getElementById(positionID) !== null) {
                            document.getElementById(positionID).innerHTML = position.pText;
                            //AI predicted results are identified as purple highlights on UI
                        }
                    }
                }

            }
        }
        // if (!lvCustomerView)
        // 	await goToLastAnnotationOnUI();
    }

    /**
     *  Get highlights from IndexedDB after we repopulate the storage with backend API data and show them on UI with
     *  respective category colour. Also, adds event listeners to the annotations (highlights) to show respective
     *  advice data on Annotation UI via mouse onclick.
     */
    async function showHighlights() {

        //let annotationsGetS = await getAllAnnotationsDB().then(function (
        //   annotations
        // ) {
        //     return annotations;
        // });
        let annotationsGetS = props.annotations
        if (annotationsGetS) {
            //Add event listeners for annotations (highlights) that shows respective advice data on Annotation UI
            $("mark").removeClass("dashed-border-mark");
            for (let annot of annotationsGetS) {
                let annotDataValue = annot
                let annotationID = annot.unique_id;
                if ("annotation_data" in annot) {
                    annotDataValue = annot.annotation_data
                }
                if (
                    (annotDataValue.type === "Potenzial" ||
                        annotDataValue.type === "Risiko") &&
                    (annotDataValue.value === "Kein Wert" ||
                        annotDataValue.value === "null" ||
                        annotDataValue.value === "")
                ) {
                    setAnnotationStale(annotationID);
                }
                if (annotationID !== null) {
                    let isWebReport = sessionStorage.getItem('webreport')
                    //updateAnnotatorUI(annotationID, annotDataValue, isWebReport, setListener);
                    updateAnnotatorUI(annotationID, annotDataValue, isWebReport);
                }
            }
        }
    }

    // On purpose made empty to render nothing
    return <></>;
}

export default ShowHighlightsComponent;